import { Query, QuerySitesArgs } from '@domain/graphql.types';
import { QuerySites } from '@infrastructure/graphql';
import { useCallback } from 'react';
import { useClient } from 'urql';

/**
 * Runs the Sites query on demand and resolves with its result, so the caller
 * decides which response is still current (see useSiteSearch).
 */
const useLazySitesQuery = () => {
  const client = useClient();

  return useCallback(
    (variables: QuerySitesArgs) => client.query<Pick<Query, 'sites'>, QuerySitesArgs>(QuerySites, variables, { requestPolicy: 'network-only' }).toPromise(),
    [client],
  );
};

export default useLazySitesQuery;
